<span *ngIf="type === CommissionPayoutType.FIXED"> {{ value | number: '1.0-2' }} € </span>
<span *ngIf="type === CommissionPayoutType.PERCENTAGE"> {{ percentage | number: '1.0-2' }}% </span>
<span *ngIf="type === CommissionPayoutType.HYBRID"> {{ value | number: '1.0-2' }} €, {{ percentage | number: '1.0-2' }}% </span>
